module.exports = __webpack_public_path__ + "media/images/shop-info-e4e0fb90.png";